import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProjectCard from '../../components/ProjectCard';
import { EmptyState, ErrorState, Loading } from '../../components/StatusStates';
import { useProjects } from '../../hooks/use-public';
import { cn } from '../../lib/format';
import { useSeo } from '../../lib/seo';
import '../../styles/public.css';

export default function Projects() {
  useSeo({
    title: '项目',
    description: '本站的项目作品，包含工程实践、开源探索与个人建设。',
  });

  const [searchParams, setSearchParams] = useSearchParams();
  const activeTag = searchParams.get('tag') ?? undefined;
  // 获取全量项目后在前端筛选，保证标签集合不会随筛选结果缩小
  const { data: allProjects, isLoading, isError, refetch } = useProjects();

  const projects = useMemo(
    () => (allProjects ?? []).filter((project) => !activeTag || project.tags.includes(activeTag)),
    [allProjects, activeTag],
  );

  const allTags = useMemo(
    () => Array.from(new Set((allProjects ?? []).flatMap((project) => project.tags))),
    [allProjects],
  );

  const setTag = (tag: string | undefined) => {
    if (tag) setSearchParams({ tag });
    else setSearchParams({});
  };

  return (
    <div className="container content-section">
      {isLoading ? (
        <Loading />
      ) : isError ? (
        <ErrorState onRetry={() => refetch()} />
      ) : (projects ?? []).length === 0 ? (
        <EmptyState title="暂无项目" description="项目内容整理完成后将在这里展示。" />
      ) : (
        <>
          {allTags.length > 0 && (
            <div className="filter-bar" role="group" aria-label="按技术标签筛选">
              <button
                type="button"
                className={cn('tag tag-clickable', !activeTag && 'tag-active')}
                onClick={() => setTag(undefined)}
              >
                全部
              </button>
              {allTags.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  className={cn('tag tag-clickable', activeTag === tag && 'tag-active')}
                  onClick={() => setTag(tag)}
                >
                  {tag}
                </button>
              ))}
            </div>
          )}
          <div className="card-grid">
            {(projects ?? []).map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
